<template>
  <FinancialCardTable
    :title="title"
    :headers="toExpireHeaders"
    :items="items"
    :unitFinancialPositions="unitFinancialPositions"
    mode="toExpire"
    :loading="loading"
    :no-data-text="pageParams.emptyState.toExpire"
    :expand-column="expandColumn"
    :slip-details-headers="slipDetailsHeaders"
  >
    <!-- Personaliza a coluna "acao" -->
    <template #col-action="{ item }">
      <payment-button
        v-if="item.allowToPay && !debitBlock"
        :item="item"
        :email="email"
        :cellphone="cellphone"
        :buttonClass="'financial--background financial__pay-btn'"
        @openSlip="OnPaySlip(selectedUnit, item)"
        :sendByEmail="OnSendSlipByEmailToExpire"
        :sendBySms="OnSendSlipBySmsToExpire"
      />
    </template>
    <template #expandcol-contractTitle="expandProps">
      <span>
        {{ getContractTitle(expandProps.item) }}
      </span>
    </template>

    <!-- Passa os slots do pai para o filho -->
    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot :name="name" v-bind="slotData" />
    </template>
  </FinancialCardTable>
</template>

<script>
import FinancialCardTable from './FinancialCardTable.vue';
import PaymentButton from '@/components/financial/PaymentButton';
import { APP, FEATURE_TOGGLES } from '../../utils/constants';
export default {
  name: 'ToExpireTable',
  components: {
    FinancialCardTable,
    PaymentButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: { type: Array, default: () => [] },
    unitFinancialPositions: { type: Object, required: true },
    slipDetailsHeaders: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    noDataText: { type: String, default: 'Nenhum dado encontrado' },
    expandColumn: {
      type: String,
      default: 'slipsUnion',
    },
    email: { type: String },
    cellphone: { type: Object },
    debitBlock: { type: Boolean },
  },
  computed: {
    unifiedSlipsEnabled() {
      return this.$store.getters[FEATURE_TOGGLES.UNIT_FINANCIAL_POSITION];
    },
    showUnifiedSingleContract() {
      return this.$store.getters[FEATURE_TOGGLES.SHOW_UNIFIED_SINGLE_CONTRACT];
    },
    toExpireHeaders() {
      return this.visibleHeaders(this.toExpireHeadersConfig);
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].financialPosition,
      expandColumnPagination: {
        sortBy: 'contractId', // campo inicial para ordenação
        descending: false, // true = decrescente, false = crescente
      },
      toExpireHeadersConfig: [
        {
          text: ' ',
          value: 'slipsUnion',
          align: 'left',
          class: 'no-print',
          sortable: false,
          width: '40px',
        },
        {
          text: 'Vencimento',
          value: 'expirationDate',
          formatter: this.formatUtcDate,
          align: 'center',
        },
        {
          text: 'Valor',
          value: 'discountedValue',
          formatter: (v, item, extraInfo, headerValue) =>
            extraInfo == this.expandColumn
              ? this.formatMoney(v, item, extraInfo, headerValue)
              : this.formatUnifiedValue(v, item, extraInfo, headerValue),
          align: 'center',
          itemClass: 'text-xs-center bold--text',
        },
        {
          text: ' ',
          value: 'action',
          align: 'center',
          class: 'no-print',
          itemClass: 'text-xs-center',
          width: '150px',
        },
      ],
    };
  },
  methods: {
    visibleHeaders(headers, mobile = this.mobile) {
      return headers.filter((header) =>
        mobile ? header.showMobile !== false : header.showDesktop !== false
      );
    },
    OnPaySlip(selectedUnit, slip) {
      if (slip.ready) {
        if (slip.slipUrl.hash) {
          window.open(getSlipUrl(slip.slipUrl.hash));
        } else {
          window.open(slip.slipUrl);
        }
      } else {
        window.open('/boleto-indisponivel');
      }
      const slipContract = this.selectedContract;
      const traceInfo = {
        contractId: slipContract.id,
        contractType: slipContract.type,
        detachedType: this.getContractTitle(slipContract),
        expirationDate: slip.expirationDate,
        serieId: slip.serieId,
        serieCode: slip.serieCode,
        parcelCode: slip.parcelCode,
        discountedValue: slip.discountedValue,
        ready: slip.ready,
        url: slip.slipUrl,
      };
      const traceAction =
        this.enums.logTraceActions.toExpirePaymentSlipDownloadFinancialPosition;
      this.createTrace(traceAction, traceInfo, this.currentContract.id);

      const notificationInfo = {
        ctx: this,
        notification: {
          id: slip.id.toString(),
          type: notificationTypes.TO_EXPIRE_SLIPS,
        },
      };
      this.$store.dispatch(NOTIFICATIONS.SAVE_VISUALIZED, notificationInfo);
    },
    async OnSendSlipByEmailToExpire(item, cellphone, fromHome = false) {
      return await this.sendSlipByEmailToExpire(
        { ...item, contractId: this.selectedContract.id },
        cellphone,
        fromHome
      );
    },
    async OnSendSlipBySmsToExpire(item, cellphone, fromHome = false) {
      return await this.sendSlipBySmsToExpire(
        { ...item, contractId: this.selectedContract.id },
        cellphone,
        fromHome
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financial/ToExpireTable.vue